import { Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import {
  Router,
  Event as RouterEvent,
} from '@angular/router';
import {
  CHEVRON_LEFT,
  DOWNLOAD,
  EDIT,
  EVENT_LANDING,
  NOT_ALLOWED,
  RESERVATION_LANDING,
} from './constants/icon';

import { ROUTES } from './route/routes';
import { CookieStoragerService } from './service/cookie-storager.service';
import { UserService } from './service/user.service';
import { LocaleService } from './service/locale.service';
import { SpinnerService } from './components/spinner/spinner.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {
  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private router: Router,
    private cStorager: CookieStoragerService,
    private userService: UserService,
    private locale: LocaleService,
    private spinner: SpinnerService,
  ) {
    this.locale.init(this.userService.lang);
    this.addSVGIcons();
    this.router.events.subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event);
    });
  }

  ngOnInit(): void {
    let cu = this.cStorager.getElement('cu');
    if (!!cu) {
      this.cStorager.clearAll();
      this.userService.buildCurrentUser(cu, false,true);
      this.router.navigateByUrl(ROUTES.HOME.absolute_path);
    }
    if (this.userService.getCurrentUser() && this.userService.isExpiredToken) {
      this.userService.logout();
    }
  }

  // Shows and hides the loading spinner during RouterEvent changes
  navigationInterceptor(event: RouterEvent): void {
    // window.scroll(0, 0);
    /*if (event instanceof NavigationStart) {
        this.spinner.show();
    }
    if (event instanceof NavigationEnd) {
      setTimeout(() => {
        this.spinner.hide();
      }, 100);
    }
    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      setTimeout(() => {
        this.spinner.hide();
      }, 100);
    }
    if (event instanceof NavigationError) {
      setTimeout(() => {
        this.spinner.hide();
      }, 100);
    }*/
  }

  private addSVGIcons() {
    // MATERIAL
    this.iconRegistry.addSvgIconLiteral(
      'edit',
      this.sanitizer.bypassSecurityTrustHtml(EDIT)
    );
    this.iconRegistry.addSvgIconLiteral(
      'download',
      this.sanitizer.bypassSecurityTrustHtml(DOWNLOAD)
    );
    this.iconRegistry.addSvgIconLiteral(
      'chevron_left',
      this.sanitizer.bypassSecurityTrustHtml(CHEVRON_LEFT)
    );

    // LANDING
    this.iconRegistry.addSvgIconLiteral(
      'event-home',
      this.sanitizer.bypassSecurityTrustHtml(EVENT_LANDING)
    );
    this.iconRegistry.addSvgIconLiteral(
      'reservation-home',
      this.sanitizer.bypassSecurityTrustHtml(RESERVATION_LANDING)
    );

    // NOT ALLOWED
    this.iconRegistry.addSvgIconLiteral(
      'not-allowed',
      this.sanitizer.bypassSecurityTrustHtml(NOT_ALLOWED)
    );
  }
}
